import { render, staticRenderFns } from "./NotifUploads.vue?vue&type=template&id=67870f22&scoped=true&"
import script from "./NotifUploads.vue?vue&type=script&lang=js&"
export * from "./NotifUploads.vue?vue&type=script&lang=js&"
import style0 from "./NotifUploads.vue?vue&type=style&index=0&id=67870f22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67870f22",
  null
  
)

export default component.exports